/**
 * Created by Jonas Wålekvist on 2018-08-29.
 */
import {BeforeSpinStopPresentationController} from "@nolimitcity/slot-game/bin/core/beforespinstoppresentation/BeforeSpinStopPresentationController";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {TimelineLite} from "gsap";
import {DirtyWildGameMode} from "../DirtyWildsRespinZeroBetController";
import {DirtyWilds} from "../../DirtyWilds";
import {DirtyWildsParsedGameData} from "../../server/data/DirtyWildsParsedGameData";
import {DirtyWildGameModuleConfig} from "../../DirtyWildGameModuleConfig";

export class DirtyWildsOverlayBeforeStopController extends BeforeSpinStopPresentationController {

    private _beforeStopSpinsRemaining:number;

    constructor(index:number, name:string) {
        super(index, name);
    }

    protected getSpinStopDelay(data:ParsedGameData):number {
        return 1;
    }


    protected parseFeatureTriggered(data:ParsedGameData):boolean {
        this._beforeStopSpinsRemaining = (<DirtyWildsParsedGameData>data).beforeStopSpinsRemaining;
        return data.mode == DirtyWildGameMode.STICKY_RESPIN;
    }

    protected resetFeature():void {
    }

    //Happens when reels are spinning and data have been received.
    protected startPresentation(timeline:TimelineLite):void {
        const tl = timeline;
        tl.add(DirtyWildGameModuleConfig.overlayController.getFadeOutOverlays(), 0);
        tl.add(DirtyWildGameModuleConfig.topBarView.removeSpins(this._beforeStopSpinsRemaining), 0);
    }

    protected stopPresentation(isAborted:boolean):void {

    }

}